export default {"src":"/_next/static/media/twitter-grey.65818405.svg","height":32,"width":32};